<ng-container *transloco="let t; read: 'user'">
  <div class="w-full">
    <div class="hidden md:block md:static ">
      @if (classId !== null) {
        <div><a class="text-sm cursor-pointer underline md:absolute md:right-32 md:mt-6" (click)="goBack()">
          <i class="uil uil-angle-left-b text-base"></i>{{ t('manageEnrollment.viewChildTabs.backToClass') }}</a></div>
        }
        @if (canEdit && activeTab === ViewChildTabs.Demographics) {
          <drdp-btn class="hidden md:block md:absolute md:right-8 md:mt-4" (click)="editChild()"
            >
            @if (!isEdit) {
              <i class="uil uil-pen cursor-pointer"></i>
            }
            {{ buttonText }}
          </drdp-btn>
        }
      </div>
      <div class="tabs-container mt-2 md:mt-0">
        <ul
          class="tabs flex overflow-x-auto list-none flex-nowrap md:flex-wrap md:pt-3 flex-row text-md font-medium text-gray-700">
          <li class="flex flex-col justify-end md:mr-2 last:mr-0 text-center rounded-t-lg cursor-pointer">
            <a class="px-2 py-2 md:px-5 md:py-3 rounded-t-lg leading-normal cursor-pointer"
            (click)="toggleTabs(ViewChildTabs.Demographics)" [ngClass]="{
                          'text-white': activeTab !== ViewChildTabs.Demographics,
                          'text-white bg-drdpblue-300': activeTab === ViewChildTabs.Demographics
                      }">
              {{ t('manageEnrollment.viewChildTabs.tabs.demographics') }}
            </a>
          </li>
          <li class="flex flex-col justify-end md:mr-2 last:mr-0 text-center rounded-t-lg cursor-pointer">
            <a class="p-2 md:px-5 md:py-3 rounded-t-lg leading-normal cursor-pointer"
            (click)="toggleTabs(ViewChildTabs.ClassEnrollment)" [ngClass]="{
                          'text-white': activeTab !== ViewChildTabs.ClassEnrollment,
                          'text-white bg-drdpblue-300': activeTab === ViewChildTabs.ClassEnrollment
                      }">
              {{ t('manageEnrollment.viewChildTabs.tabs.classEnrollment') }}
            </a>
          </li>
          <li class="flex flex-col justify-end  md:mr-2 last:mr-0 text-center rounded-t-lg cursor-pointer">
            <a class="p-2 md:px-5 md:py-3 rounded-t-lg leading-normal cursor-pointer"
            (click)="toggleTabs(ViewChildTabs.CompletedAssessments)" [ngClass]="{
                          'text-white': activeTab !== ViewChildTabs.CompletedAssessments,
                          'text-white bg-drdpblue-300': activeTab === ViewChildTabs.CompletedAssessments
                      }">
              {{ t('manageEnrollment.viewChildAssessments.pageTitle') }}
            </a>
          </li>
          @if (canViewSharedChild) {
            <li class="flex flex-col justify-end  md:mr-2 last:mr-0 text-center rounded-t-lg cursor-pointer"
              >
              <a class="p-2 md:px-5 md:py-3 rounded-t-lg leading-normal cursor-pointer"
            (click)="toggleTabs(ViewChildTabs.ShareChild)" [ngClass]="{
                          'text-white': activeTab !== ViewChildTabs.ShareChild,
                          'text-white bg-drdpblue-300': activeTab === ViewChildTabs.ShareChild
                      }">
                {{ t('manageEnrollment.sharedProviders.pageTitle') }}
              </a>
            </li>
          }
        </ul>

      </div>
      <div
        class="relative flex flex-col rounded-tr-none md:rounded-tr-3xl min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-b-[30px] min-h-[44rem]">
        <div class="flex-auto">
          <div class="tab-content tab-space">
            <div class="pb-6">
              @if (activeTab == ViewChildTabs.Demographics && !isEdit) {
                <div class="static block md:hidden">
                  @if (classId !== null) {
                    <div><a class="text-sm cursor-pointer underline absolute right-28" (click)="goBack()">
                      <i class="uil uil-angle-left-b text-base"></i>{{ t('manageEnrollment.viewChildTabs.backToClass') }}</a></div>
                    }
                    @if (canEdit && activeTab === ViewChildTabs.Demographics) {
                      <drdp-btn class=" absolute right-5" (click)="editChild()"
                        >
                        @if (!isEdit) {
                          <i class="uil uil-pen cursor-pointer"></i>
                        }
                        {{ buttonText }}
                      </drdp-btn>
                    }
                  </div>
                }
                @if (activeTab == ViewChildTabs.Demographics && !isEdit) {
                  <div>
                    <drdp-add-view-edit-child [componentType]="ComponentTypeTable.View" [childData]="childData">
                    </drdp-add-view-edit-child>
                  </div>
                }
                @if (activeTab == ViewChildTabs.Demographics && isEdit) {
                  <div>
                    <drdp-add-view-edit-child [componentType]="ComponentTypeTable.Edit" [childData]="childData"
                      (returnToView)="backToView($event)">
                    </drdp-add-view-edit-child>
                  </div>
                }
                @if (activeTab == ViewChildTabs.ClassEnrollment) {
                  <div>
                    <drdp-view-class-enrollments></drdp-view-class-enrollments>
                  </div>
                }
                @if (activeTab == ViewChildTabs.CompletedAssessments) {
                  <div>
                    <drdp-view-child-assessments></drdp-view-child-assessments>
                  </div>
                }
                @if (activeTab == ViewChildTabs.ShareChild) {
                  <div>
                    <drdp-view-child-shared-providers></drdp-view-child-shared-providers>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
</ng-container>